import {useAsync} from "react-async-hook";
import {$axios} from "../http/axiosInstance";

export const PaymentService = {
    GetPayments() {
        return useAsync(async () => {
            return await $axios.get('/admin/ransoms/payment-type/');
        }, [])
    }
}